// @ts-nocheck
import { ReactNode, useState } from 'react';
import { Box, Button, Collapse, Divider, Group, Stack, Text, Title } from '@/components/ui';
import { IconBrandGoogle, IconBrandGithub, IconBrandApple, IconBrandFacebook, IconChevronDown } from '@tabler/icons-react';

export type SocialProvider = 'google' | 'github' | 'apple' | 'facebook' | 'microsoft';

interface SocialFirstCardProps {
  providers?: SocialProvider[];
  showEmailOption?: boolean;
  emailFormContent?: ReactNode;
  title?: string;
  subtitle?: string;
  onSocialClick?: (provider: SocialProvider) => void;
}

const providerConfig = {
  google: {
    name: 'Google',
    icon: IconBrandGoogle,
    color: '#DB4437',
  },
  github: {
    name: 'GitHub',
    icon: IconBrandGithub,
    color: '#333333',
  },
  apple: {
    name: 'Apple',
    icon: IconBrandApple,
    color: '#000000',
  },
  facebook: {
    name: 'Facebook',
    icon: IconBrandFacebook,
    color: '#1877F2',
  },
  microsoft: {
    name: 'Microsoft',
    icon: IconBrandGithub, // Placeholder
    color: '#00A4EF',
  },
};

export default function SocialFirstCard({
  providers = ['google', 'apple', 'github'],
  showEmailOption = true,
  emailFormContent,
  title = 'Sign in to continue',
  subtitle = 'Choose your preferred sign in method',
  onSocialClick,
}: SocialFirstCardProps) {
  const [emailFormOpen, setEmailFormOpen] = useState(false);

  const handleSocialClick = (provider: SocialProvider) => {
    console.log(`Social login with ${provider}`);
    if (onSocialClick) {
      onSocialClick(provider);
    }
  };

  return (
    <Stack gap="lg">
      {/* Header */}
      <Stack gap="xs" align="center">
        <Title order={2} ta="center">
          {title}
        </Title>
        <Text c="dimmed" size="sm" ta="center">
          {subtitle}
        </Text>
      </Stack>

      {/* Social Login Buttons */}
      <Stack gap="md">
        {providers.map((provider) => {
          const config = providerConfig[provider];
          const Icon = config.icon;

          return (
            <Button
              key={provider}
              variant="default"
              size="lg"
              fullWidth
              leftSection={<Icon size={20} />}
              onClick={() => handleSocialClick(provider)}
              styles={{
                root: {
                  height: 56,
                  fontSize: '1rem',
                  fontWeight: 500,
                },
                section: {
                  marginRight: 12,
                },
              }}
            >
              Continue with {config.name}
            </Button>
          );
        })}
      </Stack>

      {/* Email Option */}
      {showEmailOption && (
        <>
          <Divider
            label={
              <Text size="sm" c="dimmed">
                Or
              </Text>
            }
          />

          <Button
            variant="subtle"
            size="md"
            fullWidth
            rightSection={
              <IconChevronDown
                size={16}
                style={{
                  transform: emailFormOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.2s ease',
                }}
              />
            }
            onClick={() => setEmailFormOpen(!emailFormOpen)}
          >
            Sign in with Email
          </Button>

          <Collapse in={emailFormOpen}>
            <Box mt="md">{emailFormContent}</Box>
          </Collapse>
        </>
      )}
    </Stack>
  );
}
